import { ILoggingOptions } from '../models/ILoggingOptions';


// Mock BrowserAgent temporary. Require re-installing @newrelic/browser-agent using latest version
export interface BrowserAgent {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [fn: string]: (...args: any[]) => any;
}


declare let newrelic: BrowserAgent;

export function newRelicFactory(options: ILoggingOptions): BrowserAgent {
    if (!options.enableSending || typeof newrelic === 'undefined') {
        return null;
    }
    return newrelic;
}